<template>
    <div class="card">
        <div class="card-header">
            <h4 class="card-title">
                {{$t("arqueoDeCaja")}}
            </h4>
            <p class="card-category">
                {{$t("estadoActualDeLaCaja")}}
            </p>
        </div>
        <div class="card-body">
            <div class="row">
                <div class="col-md-12">
                    <table class="table">
                        <tbody>
                        <tr>
                            <td class="text-success title">
                                <i class="fa fa-check-circle"></i> {{$t("cobrado")}}
                            </td>
                            <td class="text-success title" align="right">+ {{getTotalVentas | currency}}</td>
                        </tr>
                        <tr>
                            <td class="text-warning title">
                                <i class="fa fa-exchange-alt"></i> {{$t("cambio")}}
                            </td>
                            <td class="text-warning title" align="right">+ {{getTotalChange | currency}}</td>
                        </tr>
                        <tr>
                            <td class="text-danger title">
                                <i class="fa fa-shopping-cart"></i> {{$t("gastos")}}
                            </td>
                            <td class="text-danger title" align="right">- {{getTotalExpenses | currency}}</td>
                        </tr>
                        </tbody>
                        <tfoot>
                        <tr class="bg-secondary">
                            <td align="center" colspan="2">{{getTotal | currency}}</td>
                        </tr>
                        </tfoot>
                    </table>
                </div>
                <div class="col-md-12">
                    <div class="progress">
                        <div class="progress-bar bg-success" role="progressbar"
                             :style="{width :(getTotalVentas*100)/getTotal+'%'}" aria-valuenow="50"
                             aria-valuemin="0" aria-valuemax="100"></div>
                        <!--<div class="progress-bar bg-primary" role="progressbar" :style="{width :(getTotalPending*100)/getTotal+'%'}" aria-valuenow="30" aria-valuemin="0" aria-valuemax="100"></div>-->
                        <div class="progress-bar bg-warning" role="progressbar"
                             :style="{width :(getTotalChange*100)/getTotal+'%'}" aria-valuenow="20"
                             aria-valuemin="0" aria-valuemax="100"></div>
                        <div class="progress-bar bg-danger" role="progressbar"
                             :style="{width :(getTotalExpenses*100)/getTotal+'%'}" aria-valuenow="20"
                             aria-valuemin="0" aria-valuemax="100"></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="card-footer">
            <hr>
            <div class="stats">
                <i class="fa fa-clock"></i> {{lastDate | timeago}}
            </div>
        </div>
    </div>
</template>
<script>

    export default {

        created() {

        },
        props: ['onlineDetails', 'lastDate'],
        data() {
            return {}
        },
        computed: {
            getTotalVentas() {
                var total = 0;

                if (this.onlineDetails) {
                    for (var i = 0; i < this.onlineDetails.length; i++) {
                        if (this.onlineDetails[i]) {
                            total += this.onlineDetails[i].money + this.onlineDetails[i].cards + this.onlineDetails[i].checks;
                        }
                    }
                }

                return total;
            },
            getTotalPending() {
                var total = 0;

                if (this.onlineDetails) {
                    for (var i = 0; i < this.onlineDetails.length; i++) {
                        if (this.onlineDetails[i]) {
                            total += this.onlineDetails[i].pending;
                        }
                    }
                }

                return total;
            },
            getTotalChange() {
                var total = 0;

                if (this.onlineDetails) {
                    for (var i = 0; i < this.onlineDetails.length; i++) {
                        if (this.onlineDetails[i]) {
                            total += this.onlineDetails[i].cashChange;
                        }
                    }
                }

                return total;
            },
            getTotalExpenses() {
                var total = 0;

                if (this.onlineDetails) {
                    for (var i = 0; i < this.onlineDetails.length; i++) {
                        if (this.onlineDetails[i]) {
                            total += this.onlineDetails[i].cashExpenses;
                        }
                    }
                }

                return total;
            },
            getTotal() {
                var total = 0;

                if (this.onlineDetails) {
                    for (var i = 0; i < this.onlineDetails.length; i++) {
                        if (this.onlineDetails[i]) {
                            total += this.onlineDetails[i].money + this.onlineDetails[i].cards + this.onlineDetails[i].checks;
                        }
                    }
                }

                if (this.onlineDetails) {
                    for (var i = 0; i < this.onlineDetails.length; i++) {
                        if (this.onlineDetails[i]) {
                            total += this.onlineDetails[i].cashChange;
                        }
                    }
                }

                if (this.onlineDetails) {
                    for (var i = 0; i < this.onlineDetails.length; i++) {
                        if (this.onlineDetails[i]) {
                            total -= this.onlineDetails[i].cashExpenses;
                        }
                    }
                }

                return total;
            }
        }

    }
</script>
<style scoped>
    .card-body {
        padding: 10px 15px;
    }

    .title {
        font-weight: bold;
    }

    tfoot tr td {
        font-size: 1.2em;
        color: #fff;
        text-shadow: 1px 1px #111;
        font-weight: bold;
    }

    .progress {
        height: 15px !important;
    }

    .card-category {
        color: #9a9a9a
    }


</style>



// WEBPACK FOOTER //
// src/pages/Dashboard/Online/Widgets/TotalCaja.vue